import type { IconType } from '../types';
import type { BlueprintIconNames } from './BlueprintIconNames';
import Action from './svg/Action';
import ActionList from './svg/ActionList';
import Activity from './svg/Activity';
import AddressCard from './svg/AddressCard';
import Archive from './svg/Archive';
import Aspect from './svg/Aspect';
import BalanceScale from './svg/BalanceScale';
import Bell from './svg/Bell';
import Briefcase from './svg/Briefcase';
import Building from './svg/Building';
import Calendar from './svg/Calendar';
import CalendarCheck from './svg/CalendarCheck';
import Change from './svg/Change';
import ChartLine from './svg/ChartLine';
import ChartPie from './svg/ChartPie';
import Clipboard from './svg/Clipboard';
import Comment from './svg/Comment';
import Decision from './svg/Decision';
import Document from './svg/Document';
import DocumentPencil from './svg/DocumentPencil';
import Envelope from './svg/Envelope';
import Fire from './svg/Fire';
import FireExtinguisher from './svg/FireExtinguisher';
import Flag from './svg/Flag';
import Folder from './svg/Folder';
import Function from './svg/Function';
import Globe from './svg/Globe';
import Goal from './svg/Goal';
import Graduate from './svg/Graduate';
import Hazard from './svg/Hazard';
import Home from './svg/Home';
import Image from './svg/Image';
import Information from './svg/Information';
import Interface from './svg/Interface';
import Issue from './svg/Issue';
import Laptop from './svg/Laptop';
import Marker from './svg/Marker';
import Meeting from './svg/Meeting';
import Megaphone from './svg/Megaphone';
import Node from './svg/Node';
import Note from './svg/Note';
import Object from './svg/Object';
import Objects from './svg/Objects';
import Organization from './svg/Organization';
import Person from './svg/Person';
import Persons from './svg/Persons';
import Phase from './svg/Phase';
import Pin from './svg/Pin';
import Plus from './svg/Plus';
import Quantification from './svg/Quantification';
import Question from './svg/Question';
import Requirement from './svg/Requirement';
import Risk from './svg/Risk';
import Stakeholder from './svg/Stakeholder';
import System from './svg/System';
import Table from './svg/Table';
import Tag from './svg/Tag';
import Type from './svg/Type';
import Variant from './svg/Variant';
import Verification from './svg/Verification';
import WorkPackage from './svg/WorkPackage';

export const BlueprintIcons: Record<BlueprintIconNames, IconType> = {
  Action: Action,
  ActionList: ActionList,
  Activity: Activity,
  AddressCard: AddressCard,
  Archive: Archive,
  Aspect: Aspect,
  BalanceScale: BalanceScale,
  Bell: Bell,
  Briefcase: Briefcase,
  Building: Building,
  Calendar: Calendar,
  CalendarCheck: CalendarCheck,
  Change: Change,
  ChartLine: ChartLine,
  ChartPie: ChartPie,
  Clipboard: Clipboard,
  Comment: Comment,
  Decision: Decision,
  Document: Document,
  DocumentPencil: DocumentPencil,
  Envelope: Envelope,
  Fire: Fire,
  FireExtinguisher: FireExtinguisher,
  Flag: Flag,
  Folder: Folder,
  Function: Function,
  Globe: Globe,
  Goal: Goal,
  Graduate: Graduate,
  Hazard: Hazard,
  Home: Home,
  Image: Image,
  Information: Information,
  Interface: Interface,
  Issue: Issue,
  Laptop: Laptop,
  Marker: Marker,
  Meeting: Meeting,
  Megaphone: Megaphone,
  Node: Node,
  Note: Note,
  Object: Object,
  Objects: Objects,
  Organization: Organization,
  Person: Person,
  Persons: Persons,
  Phase: Phase,
  Pin: Pin,
  Plus: Plus,
  Quantification: Quantification,
  Question: Question,
  Requirement: Requirement,
  Risk: Risk,
  Stakeholder: Stakeholder,
  System: System,
  Table: Table,
  Tag: Tag,
  Type: Type,
  Variant: Variant,
  Verification: Verification,
  WorkPackage: WorkPackage
};
